<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">PENGIRAAN KUP SSPA</h3>
            <br />
            <div class="pl-lg-2">
                <validation-provider name="Amaun Dalam Buku Servis" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="3"> Amaun Dalam Buku Servis </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <b-form-input id="AmaunTelahTerima" v-model="Obj.AmaunTelahTerima" :state="getValidation(validationContext)"></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Status SSPA " :rules="{ required: true }" v-slot="validationContext" :immediate="true">
                    <b-row class="my-1">
                        <b-col sm="3">Pelarasan Gaji SSPA</b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio v-model="Obj.SSPAStatus" :aria-describedby="ariaDescribedby" name="SSPAStatusRadios" value="1" :state="getValidation(validationContext)">FASA 1</b-form-radio>
                                <b-form-radio v-model="Obj.SSPAStatus" :aria-describedby="ariaDescribedby" name="SSPAStatusRadios" value="2" :state="getValidation(validationContext)">FASA 2</b-form-radio>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />

                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="3"> Catatan </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="8">
                            <!-- <b-form-input v-model="Obj.Catatan" :state="getValidation(validationContext)" class="custom-input"></b-form-input> -->
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" :state="getValidation(validationContext)" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit" :disabled="invalid">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun"],
    data() {
        return {
            Obj: {
                AmaunTelahTerima: 0.00,
                Catatan: "INI ADALAH PENGIRAAN KUP SSPA",
                SSPAStatus: null, // Tambah ini
                GredSemasa: null, // Tambah ini

            },
            StatusSimpan: {},
        };
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;

            this.Obj.elemenId = 26,

                GetsalaryService.simpan_elemenKUPSSPAF2(this.Obj).then((resp) => {
                    this.StatusSimpan = resp.data;
                }).then(() => {

                    console.log("StatusSimpan", this.StatusSimpan);

                    if (this.StatusSimpan.Status == 1) {
                        swal
                            .fire({
                                title: "BERJAYA DI SIMPAN!",
                                text: "CLICK OK UNTUK TERUSKAN.",
                                icon: "success",
                            })
                            .then(() => {
                                this.$emit("batal");
                            });
                    } else {
                        swal.fire({
                            title: this.StatusSimpan.details,
                            text: "CLICK OK UNTUK TERUSKAN.",
                            icon: "error",
                        }).then(() => {
                            this.$emit("batal");
                        });
                    }
                });
        }
    },
    computed: {
        coid() {
            return Store.state.MaklumatPeribadi[0].coid;
        }
    },
    created() {
        // this.Obj = Store.state.MaklumatPeribadi;

    }
};
</script>

<style scoped>
.custom-input-large {
    font-size: 1.25rem;
    /* Atur ukuran font lebih besar */
    padding: .75rem 1.5rem;
    /* Sesuaikan padding input */
    height: auto;
    /* Sesuaikan tinggi input */
}
</style>
